<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <el-main v-if="mode == 'login' || mode == 'pin'" v-loading="loading" style="text-align: center"
                :class="{ 'apply-shake': shake }">
                <h2 :class="shake ? 'instrucciones red' : 'instrucciones'">{{ instrucciones }}</h2>
                <div class="contenedorSalida">
                    <div v-for="(salida, s) in salida" :key="s">{{ mode == "pin" || mode == "cambiarPin" ? "*" :
                        salida }}
                    </div>
                </div>
                <ul class="contenedorNumeros">
                    <li v-for="(boton, b) in botones" :key="b" @click="anadirContenido(boton)" :class="boton.tipo">
                        <font-awesome-icon v-if="boton.icon" :icon="boton.icon" />
                        <p v-else>{{ boton.valor }}</p>
                    </li>
                </ul>
                <div v-if="mode == 'login'" class="dni-switch">
                    <el-switch v-model="checkGuardar" active-text="Guardar DNI para iniciar sesión automáticamente" />
                </div>
            </el-main>
            <el-main v-loading="true" v-if="mode == 'validate'" style="text-align: center"
                :class="{ 'apply-shake': shake }">
                <h2 :class="shake ? 'instrucciones red' : 'instrucciones'">Cargando...</h2>
            </el-main>
            <el-main v-loading="true" v-if="mode == 'validatepin'" style="text-align: center"
                :class="{ 'apply-shake': shake }">
                <h2 :class="shake ? 'instrucciones red' : 'instrucciones'">Cargando...</h2>
            </el-main>
        </div>
    </el-col>
</template>

<script>
import { ElNotification } from 'element-plus';
import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
export default {
    name: 'PinPad',
    watch: {
        salida() {
            if (this.salida.length == 0) {
                this.botones[9]['icon'] = ['fas', 'arrow-left']
            } else {
                this.botones[9]['icon'] = ['fas', 'xmark']
            }
        }
    },
    data() {
        return {
            loading: false,
            instrucciones: 'Introduce tu DNI',
            shake: false,
            botones: [
                {
                    valor: 1,
                    texto: 1,
                    tipo: "primary",
                },
                {
                    valor: 2,
                    texto: 2,
                    tipo: "primary",
                },
                {
                    valor: 3,
                    texto: 3,
                    tipo: "primary",
                },
                {
                    valor: 4,
                    texto: 4,
                    tipo: "primary",
                },
                {
                    valor: 5,
                    texto: 5,
                    tipo: "primary",
                },
                {
                    valor: 6,
                    texto: 6,
                    tipo: "primary",
                },
                {
                    valor: 7,
                    texto: 7,
                    tipo: "primary",
                },
                {
                    valor: 8,
                    texto: 8,
                    tipo: "primary",
                },
                {
                    valor: 9,
                    texto: 9,
                    tipo: "primary",
                },
                {
                    valor: "Del",
                    tipo: "danger",
                    icon: ['fas', 'arrow-left'],
                },
                {
                    valor: 0,
                    texto: 0,
                    tipo: "primary",
                },
                {
                    valor: "Intro",
                    tipo: "success",
                    icon: ['fas', 'arrow-right'],
                },
            ],
            mode: 'login',
            salida: [],
            checkGuardar: false,
            permisos: {},
            numReceptores: [],
            working: process.env.VUE_APP_WORKING
        }
    },
    mounted() {
        if (this.params && this.params.get('dni')) {
            this.mode = "validate"
            this.salida = this.params.get('dni').replace(/[a-zA-Z]/g, '');
            this.validarDNI();
        }
        if (localStorage.dni) {
            this.checkGuardar = true;
            this.mode = "validate"
        }
        if ((localStorage.dni) && this.mode == "validate") {
            this.salida = localStorage.dni;
            this.validarDNI();
        }
        window.addEventListener('keyup', this.teclaPresionada);
        console.log('Hola');
    },
    beforeUnmount() {
        window.removeEventListener('keyup', this.teclaPresionada);
    },
    computed: mapState([
        'datosemp', 'receptores', 'datos', 'params'
    ]),
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores',
            'setNumReceptores',
            'setParams',
            'setCarpetas',
        ]),
        cambiarModo(modo) {
            this.loading = true;
            this.mode = "none";
            setTimeout(() => {
                this.mode = modo;
                this.loading = false;
            }, 400)
        },
        shakeAnimation() {
            this.shake = true;
            setTimeout(() => {
                this.shake = false;
            }, 820); // timeout value depending on the duration of the animation
        },
        anadirContenido(boton) {
            if (this.mode == 'login' || this.mode == 'pin') {
                if (isNaN(boton.valor)) {
                    if (boton.valor == "Del") {
                        this.salida = [];
                    } else if (boton.valor == "Intro") {
                        this.validarDNI();
                    }
                } else {
                    if (this.salida.length < 8) {
                        this.salida.push(boton.valor);
                    } else {
                        ElNotification({
                            title: 'Advertencia',
                            message: 'Has llegado al límite de caracteres permitidos',
                            type: 'warning',
                        })
                    }
                }
            }
        },
        teclaPresionada(e) {
                if (!isNaN(e.key) && e.key <= 9 && e.key != '0') {
                    this.anadirContenido(this.botones[e.key - 1]);
                }
                if (e.key == "Enter") {
                    this.anadirContenido(this.botones[11]);
                }
                if (e.key == "Backspace") {
                    this.anadirContenido(this.botones[9]);
                }
                if (e.key == '0') {
                    this.anadirContenido(this.botones[10]);
                }
        },
        async validarDNI() {
            this.loading = true;
            if (this.mode == "login" || this.mode == "validate") {
                if (typeof (this.salida) === "object") {
                    this.salida = this.salida.join("");
                }
                if (this.salida.length == 7 || this.salida.length == 8) {
                    let data = {
                        url: process.env.VUE_APP_APIDOMAIN + 'firmas/verificarExistenciaEmpleado',
                        body: {
                            'validarDNI': true,
                            'dni': this.salida,
                        }
                    }
                    let resp = await curl(data)
                    if (resp) {
                        if (resp.status == 200) {
                            resp = await resp.json();
                            resp.datosemp[0].saludo = "Hola, " + resp.datosemp[0].name.split(' ')[0];
                            this.setDatosemp(resp.datosemp[0])
                            this.dni = this.salida;
                            if (this.checkGuardar) {
                                localStorage.dni = this.salida;
                            }
                            this.datos = resp;
                            this.cambiarModo("pin");
                            this.instrucciones = 'Introduce tu PIN';
                            if (this.params.get('pin')) {
                                setTimeout(() => {
                                    this.mode = 'validatepin';
                                    this.salida = this.params.get('pin').split();
                                    this.validarDNI();
                                }, 401)
                            }
                        } else {
                            this.shakeAnimation();
                        }
                    } else {
                        this.shakeAnimation();
                        this.$message({
                            message: "No se ha establecido conexión con el servidor",
                            type: "error",
                        });
                        this.cambiarModo('login');
                        localStorage.dni = "";
                        this.checkGuardar = false;
                    }
                } else {
                    this.shakeAnimation();
                }
            } else if (this.mode == "pin" || this.mode == 'validatetoken' || this.mode == 'validatepin') {
                let data = {
                    url: process.env.VUE_APP_APIDOMAIN + 'firmas/validarPIN',
                    body: {
                        'dni': this.datosemp.dni,
                        'pin': this.salida.join(""),
                    }
                }
                let resp = await curl(data);
                if (resp.status == 200) {
                    resp = await resp.json();
                    this.datosemp.token = resp.datosemp[0].token;
                    this.datos = resp.datosemp;
                    this.setReceptores(resp.datos);
                    if (this.working == 'firmas') {
                        let respcontactos = await fetch(process.env.VUE_APP_APIDOMAIN + 'firmas/obtenerContactos', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({ token: this.datosemp.token })
                        });
                        if (respcontactos.status == 200) {
                            this.setReceptores(await respcontactos.json());
                        }
                    } else {
                        this.setCarpetas(resp.tipos);
                    this.permisos.documentos = resp.permisos.find((permiso) => { return permiso.rol == 'enviarDocumentos' }) ? 1 : 0;
                    this.permisos.firmas = resp.permisos.find((permiso) => { return permiso.rol == 'enviarFirmas' }) ? 1 : 0;
                    this.permisos.borrar = resp.permisos.find((permiso) => { return permiso.rol == 'borrarDocumentos' }) ? 1 : 0;
                    this.permisos.subir = resp.permisos.find((permiso) => { return permiso.rol == 'subirDocumentos' }) ? 1 : 0;
                    this.datos.permisos = this.permisos;
                    let numempresas = resp.datos.filter(function (empresa) {
                        return empresa.tipo == "empresa";
                    });
                    let numareas = resp.datos.filter(function (area) {
                        return area.tipo == "área";
                    });
                    let numcentros = resp.datos.filter(function (centro) {
                        return centro.tipo == "centro";
                    });
                    this.numReceptores = {
                        empresas: numempresas.length,
                        areas: numareas.length,
                        centros: numcentros.length,
                        total: 0,
                    };
                    this.numReceptores.total = this.numReceptores.empresas + this.numReceptores.areas + this.numReceptores.centros;
                    this.setNumReceptores(this.numReceptores);
                }
                    // this.obtenerDatosFirma();
                    // Vue.use(VueMqtt, process.env.VUE_APP_WSDOM, {
                    //     clientId: this.token,
                    //     clean: true, // Establecer la opción clean en false para una sesión persistente
                    // });
                    // this.$mqtt.subscribe('documentos/notificaciones/' + this.token, { qos: 2 });
                    // this.$mqtt.subscribe('documentos/recarga');
                    // this.$mqtt.on('message', this.onMessage);
                    // const promesaObtenerUltimosArchivos = this.obtenerUltimosArchivos();
                    // const promesaObtenerMisArchivos = this.obtenerMisArchivos();
                    // // Esperar a que ambas promesas se resuelvan
                    // await Promise.all([promesaObtenerUltimosArchivos, promesaObtenerMisArchivos]);
                    this.$router.push('/dashboard');
                } else {
                    this.shakeAnimation();
                }
            }
            this.salida = [];
            this.loading = false;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }


    ul.contenedorNumeros {
        display: flex;
        padding: 0px;
        margin: 0 auto;
        list-style: none;
        flex-wrap: wrap;
        max-width: 300px;
        justify-content: center;

        li {
            width: 80px;
            height: 80px;
            background-color: #f9f9f9;
            border: 1px solid #dedede;
            border-radius: 50%;
            display: flex;
            align-items: Center;
            justify-content: center;
            font-size: 1.5rem;
            margin: 5px;
            color: #585858;
            font-weight: 500;
            cursor: pointer;
            transition: 0.4s;

            &:hover {
                background-color: #dedede;
                border: 1px solid #a0a0a0;
            }

            &.danger {
                color: #F56C6C;
                background-color: rgb(253, 226, 226);
                border-color: #F56C6C;

                &:hover {
                    background-color: #F56C6C;
                    color: rgb(253, 226, 226);
                }
            }

            &.success {
                color: #67C23A;
                background-color: rgb(225, 243, 216);
                border-color: #67C23A;

                &:hover {
                    color: rgb(225, 243, 216);
                    background-color: #67C23A;
                }
            }
        }
    }

    .contenedorSalida {
        display: flex;
        justify-content: center;
        margin: auto;
        border-radius: 5px;
        min-height: 50px;
        border: 1px solid #e9e9e9;
        width: 270px;
        margin-bottom: 25px;
        padding: 0px 10px;

        div {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            width: 30px;
            font-size: 1.8rem;
            margin: 2px;
            padding: 4px;
        }
    }

    .dni-switch {
        margin: 30px 0px;
    }

}
</style>